export const PERSONS = {
    1: {
        id: 1,
        name: `Jacob Toye`,
        phoneNumber: `021876648`,
        email: `jacob@smartrak.co.nz`,
    },
    2: {
        id: 2,
        name: `Steven Crake`,
        phoneNumber: `0273691145`,
        email: `steven@smartrak.co.nz`,
    },
    3: {
        id: 3,
        name: `Kerry Arts`,
        phoneNumber: `0223141593`,
        email: `kerry@smartrak.co.nz`,
    },
};



// WEBPACK FOOTER //
// ./scripts/constants/fakeData/persons.js